import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("auto-header")
export class AutoHeader extends LitElement {
  @property() tile: string;

  static styles = css`
    header {
      border-bottom: 1px solid #999;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }

    h1 {
      margin: 0;
      padding: 8px 16px;
    }
  `;

  render() {
    return html`
      <header>
        <h1>${this.title}</h1>
      </header>
    `;
  }
}
